import { openErrorToast } from '@pct/ng-feature-message';
import type { CappusError } from '../error/cappus-error';
import type { CappusErrorHandler } from '../cappus-error-handler';

export class ServerErrorHandler implements CappusErrorHandler {
  canHandle(err: CappusError): boolean {
    return err.status >= 500;
  }

  handle(): Promise<void> {
    openErrorToast({ message: `COMMON.UNKNOWN_ERROR` });
    return Promise.resolve();
  }
}
